import axios from './index'

export default {
  list() {
    return axios.get('/api/v1/area')
  },
}